/** One way every case list orders, dates and searches — newest application at the top, everywhere. */

export const RANGES = [
  { key: "any", label: "Any time" },
  { key: "today", label: "Today" },
  { key: "week", label: "This week" },
  { key: "month", label: "This month" },
  { key: "30d", label: "Last 30 days" },
  { key: "custom", label: "Pick dates…" },
];

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

/** [from, to) in ms for a range key; null means no bound. Weeks start on Monday, the UK way. */
export function rangeBounds({ key = "any", from, to } = {}) {
  const now = new Date();
  const today = startOfDay(now).getTime();
  if (key === "today") return [today, null];
  if (key === "week") return [today - (((now.getDay() + 6) % 7) * 86400000), null];
  if (key === "month") return [new Date(now.getFullYear(), now.getMonth(), 1).getTime(), null];
  if (key === "30d") return [today - 29 * 86400000, null];
  if (key === "custom") {
    const a = from ? new Date(`${from}T00:00:00`).getTime() : null;
    const b = to ? new Date(`${to}T00:00:00`).getTime() + 86400000 : null;
    return [a, b];
  }
  return [null, null];
}

export const inRange = (iso, range) => {
  const [a, b] = rangeBounds(range);
  if (a === null && b === null) return true;
  const t = iso ? new Date(iso).getTime() : NaN;
  if (Number.isNaN(t)) return false;
  return (a === null || t >= a) && (b === null || t < b);
};

export const newestFirst = (rows, key = "created_at") =>
  [...(rows || [])].sort((x, y) => String(y?.[key] || y?.created_at || "").localeCompare(String(x?.[key] || x?.created_at || "")));

const digits = (s) => String(s || "").replace(/\D/g, "");
const national = (d) => (d.startsWith("44") ? `0${d.slice(2)}` : d);

/** Name, company, reference, email, phone (any format) or company number. */
export function matchesCase(row, needle, extra = []) {
  const n = String(needle || "").trim().toLowerCase();
  if (!n) return true;
  const hay = [row?.applicant_name, row?.business_name, row?.reference, row?.applicant_email, row?.finance_type,
               row?.company_number, row?.industry_sector, ...extra].filter(Boolean).join(" ").toLowerCase();
  if (hay.includes(n)) return true;
  const d = national(digits(n));
  if (d.length < 4) return false;
  const phone = national(digits(row?.applicant_phone));
  return !!phone && phone.includes(d);
}

export const rangeWords = (range) => {
  if (!range || range.key === "any") return "";
  if (range.key !== "custom") return RANGES.find((r) => r.key === range.key)?.label.toLowerCase() || "";
  return [range.from && `from ${range.from}`, range.to && `to ${range.to}`].filter(Boolean).join(" ");
};
